const initialState = {
  period: {
    from: null,
    to: null,
  },
  filters: {
    teamList: [],
    userList: [],
    projectList: [],
  },
  inboxFilters: {
    userList: {
      list: [],
      totalCount: 0,
      forceSelectAll: false,
    },
    projectList: {
      list: [],
      totalCount: 0,
      forceSelectAll: false,
    },
  },
  results: {
    header: {},
    users: [],
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_REPORTS_PERIOD':
      return {
        ...state,
        period: {
          ...state.period,
          [action.periodType]: action.value,
        },
      };

    case 'SET_REPORTS_PERIOD_FROM_TO':
      return {
        ...state,
        period: {
          from: action.from,
          to: action.to,
          period: action.period,
        },
      };

    case 'INITIALIZE_REPORTS_FILTERS_WITH_PERIOD':
      return {
        ...state,
        filters: action.filters,
        period: {
          from: action.from,
          to: action.to,
          period: action.period,
        },
      };

    case 'SET_REPORTS_FILTERS':
      return {
        ...state,
        filters: action.filters,
      };

    case 'UPDATE_REPORTS_INIT_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filter]: action.data,
        },
      };

    case 'UPDATE_REPORTS_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filter]: state.filters[action.filter].map((f) => {
            if (f.id === action.id) {
              return {
                ...f,
                ...action.update,
              };
            }

            return f;
          }),
        },
      };

    case 'RESET_REPORTS_FILTERS': {
      return {
        ...state,
        period: {
          from: null,
          to: null,
        },
        filters: {
          teamList: state.filters.teamList
            ? state.filters.teamList.map((f) => ({ ...f, isSelected: false }))
            : [],
          userList: state.filters.userList
            ? state.filters.userList.map((f) => ({ ...f, isSelected: false }))
            : [],
          projectList: state.filters.projectList
            ? state.filters.projectList.map((f) => ({
                ...f,
                isSelected: false,
              }))
            : [],
        },
      };
    }

    case 'INITIALIZE_INBOX_REPORTS_FILTERS':
      return {
        ...state,
        period: {
          from: action.from,
          to: action.to,
          period: action.period,
        },
      };

    case 'UPDATE_REPORTS_INBOX_FILTER':
      return {
        ...state,
        inboxFilters: {
          ...state.inboxFilters,
          [action.filter]: {
            list: action.data
              ? action.data
              : state.inboxFilters[action.filter].list,
            totalCount: action.totalCount
              ? action.totalCount
              : state.inboxFilters[action.filter].totalCount,
            forceSelectAll:
              action.forceSelectAll !== undefined
                ? action.forceSelectAll
                : state.inboxFilters[action.filter].forceSelectAll,
          },
        },
      };

    case 'RESET_INBOX_REPORTS_FILTERS': {
      return {
        ...state,
        period: {
          from: null,
          to: null,
        },
        inboxFilters: {
          userList: {
            list: [],
            totalCount: 0,
            forceSelectAll: false,
          },
          projectList: {
            list: [],
            totalCount: 0,
            forceSelectAll: false,
          },
        },
      };
    }

    case 'SELECT_ALL_REPORTS_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filter]: state.filters[action.filter].map((f) => {
            return { ...f, isSelected: action.value };
          }),
        },
      };

    case 'SET_REPORTS_RESULTS':
      return {
        ...state,
        results: action.results,
      };

    default:
      return state;
  }
}
